import React from "react";
import {FieldProps, getIn} from "formik";
import {KeyboardDateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import {useTranslation} from "react-i18next";

type DatePickerProps = {}

const DatePickerWithErrorMessage: React.FC<FieldProps & DatePickerProps> = ({field, form, ...props}) => {

    const {t} = useTranslation();

    const error = getIn(form.errors, field.name);
    const touch = getIn(form.touched, field.name);
    const errorText = touch && error ? error : null;

    return <MuiPickersUtilsProvider utils={MomentUtils}>
        <KeyboardDateTimePicker {...field} {...props}
                                format="YYYY-MM-DD HH:mm" fullWidth
                                margin="normal"
                                autoOk maskChar="_"
                                error={!!errorText}
                                helperText={t(errorText)}
                                onChange={(v) => {
                                    v === null ? form.setFieldValue(field.name, "") : form.setFieldValue(field.name, v)
                                }}


        />
    </MuiPickersUtilsProvider>
};

export default DatePickerWithErrorMessage;